/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import Checkbox from "@material-ui/core/Checkbox";
import MyLatLonEditor from "./LatLonEditor";
import ConfirmDialog from "../ConfirmDialog";
import LoaiTauEditDialog from "../danhmuc/LoaiTauEditDialog";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";
import { FormHelperText } from "@material-ui/core";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
const uuidV4 = require("uuid/v4");

const defaultRecord = {
  MaSK: null,
  MaPT: null,
  STT: 1,
  TenTau: null,
  HoHieu: null,
  IMO: null,
  MaQG: { value: "VNM", label: "Viet Nam" },
  MMSI: null,
  LoaiTau: null,
  TrongTai: null,
  SoNguoi: null,
  ThongTin: null,
  SatPhone: null,
  TuyenDuong1: null,
  TuyenDuong2: null,
  TenChuTau: null,
  DiaChi: null,
  Fax: null,
  TrucTiep: null,
  GianTiep: null,
  BiDam: null,
};

///////////////////////////////////////////////////////////////////
class SuKienPhuongTienControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      dataSaved: props.value !== undefined, //ban ghi da duoc cap nhat hay chua
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //confirm xoa phuong tien
      showConfirmXoa: false,
      //danh muc quoc gia
      loading_quoctich: true, // co dang loading danh muc quoc gia khong
      source_quoctich: [], //danh muc options cho quoc tich
      //danh muc loai tau
      loading_loaitau: true, // co dang loading danh muc loai tau
      source_loaitau: [], //danh muc options cho loai tau
      open_them_loaitau: false,
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? { ...defaultRecord, STT: props.stt, MaPT: uuidV4() + "" }
          : {
              ...defaultRecord,
              STT: props.stt,
              MaPT: uuidV4() + "",
              ...props.value,
            }, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
      tracuu_menu_anchor: null, //hien thi menu
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "TenTau",
      "HoHieu",
      "IMO",
      "MaQG",
      "MMSI",
      "LoaiTau",
      "TrongTai",
      "SoNguoi",
      "ThongTin",
      "SatPhone",
      "TuyenDuong1",
      "TuyenDuong2",
      "TenChuTau",
      "DiaChi",
      "Fax",
      "TrucTiep",
      "GianTiep",
      "BiDam",
    ]);
    s.canSaved = s.dataChanged;
    console.log(s);
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }    
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log("phuong tien ", JSON.stringify(this.state.after));
    var check = sukienLayer.validate("phuongtien", this.state.after);
    console.log("check ", check);
    if (!check.error) {
      this.setState({ validateStatus: {}, saving: true, errorLog: "" });
      server
        .post(
          "sukien/savePhuongTien",
          sukienLayer.chuanHoaSukien("phuongtien", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = { ...this.state.after };
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
            dataSaved: true,
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc quoc gia
    server
      .query("quocgia/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaQG, label: item.TenQuocGia })
        );
        this.setState({ source_quoctich: list, loading_quoctich: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_quoctich: false });
      });
    //load danh muc loai tau bao nan
    server
      .query("loaitau/getloaitau")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.LoaiTau, label: item.TenLoaiTau })
        );
        this.setState({ source_loaitau: list, loading_loaitau: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_loaitau: false });
      });
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    if (props.value !== undefined) {
      newState.after.MaSK = props.value.MaSK; //lay ma su kien thong qua props
    }
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    console.log(this.props.allowAddMore, "adddmore");
    return (
      <Accordion disabled={this.props.disabled} 
      defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>
            Thông tin phương tiện{" "}
            {this.props.stt === 1 ? undefined : " thứ " + this.props.stt}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                id="txtTenTau"
                className={classes.textbox}
                label="Tên tàu(*):"
                value={this.state.after.TenTau}
                inputProps={{
                  className: classes.uppercaseText,
                  maxLength: 200,
                }}
                onChange={(event) =>
                  this.saveField("TenTau", event.target.value)
                }
                error={this.state.validateStatus.TenTau !== undefined}
                helperText={
                  this.state.validateStatus.TenTau !== undefined
                    ? this.state.validateStatus.TenTau.trangthai
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtHoHieu"
                className={classes.textbox}
                label="Hô hiệu:"
                value={this.state.after.HoHieu}
                inputProps={{
                  className: classes.uppercaseText,
                  maxLength: 20,
                }}
                onChange={(event) =>
                  this.saveField("HoHieu", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtIMO"
                className={classes.textbox}
                label="IMO:"
                value={this.state.after.IMO}
                inputProps={{
                  className: classes.uppercaseText,
                  maxLength: 9,
                }}
                onChange={(event) => this.saveField("IMO", event.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <InputLabel id="labelQuoctich">Quốc tịch(*):</InputLabel>
              {this.state.loading_quoctich ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cboMaQG"
                  options={this.state.source_quoctich}
                  placeholder="---Chọn---"
                  labelId="labelQuoctich"
                  value={this.state.after.MaQG}
                  onChange={(item) => this.saveField("MaQG", item)}
                ></SelectFilter>
              )}
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtMMSI"
                className={classes.textbox}
                label="MMSI:"
                value={this.state.after.MMSI}
                inputProps={{
                  maxLength: 9,
                }}
                onChange={(event) => this.saveField("MMSI", event.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <InputLabel
                id="labelLoaitau"
                className={
                  this.state.validateStatus.LoaiTau !== undefined
                    ? classes.redLabel
                    : classes.normalLabel
                }
                onClick={
                  global.User.Quyen.R131
                    ? (event) => this.setState({ open_them_loaitau: true })
                    : undefined
                }
              >
                Loại tàu(*):
              </InputLabel>
              {this.state.loading_loaitau ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cbLoaiTau"
                  options={this.state.source_loaitau}
                  placeholder="---Chọn---"
                  labelId="labelLoaitau"
                  value={this.state.after.LoaiTau}
                  onChange={(item) => this.saveField("LoaiTau", item)}
                ></SelectFilter>
              )}
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtTrongTai"
                className={classes.textbox}
                label="Trọng tải:"
                type="number"
                value={this.state.after.TrongTai}
                inputProps={{
                  maxLength: 9,
                }}
                onChange={(event) =>
                  this.saveField("TrongTai", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtSoNguoi"
                className={classes.textbox}
                label="Số người:"
                type="number"
                value={this.state.after.SoNguoi}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("SoNguoi", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtThongTin"
                className={classes.textbox}
                label="Nhận dạng khác:"
                value={this.state.after.ThongTin}
                inputProps={{
                  maxLength: 128,
                }}
                onChange={(event) =>
                  this.saveField("ThongTin", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtSatPhone"
                className={classes.textbox}
                label="Thoại vệ tinh:"
                value={this.state.after.SatPhone}
                inputProps={{
                  maxLength: 20,
                }}
                onChange={(event) =>
                  this.saveField("SatPhone", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtTuyenDuong1"
                className={classes.textbox}
                label="Hành trình từ:"
                value={this.state.after.TuyenDuong1}
                inputProps={{
                  maxLength: 50,
                }}
                onChange={(event) =>
                  this.saveField("TuyenDuong1", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtTuyenDuong2"
                className={classes.textbox}
                label="Đích đến:"
                value={this.state.after.TuyenDuong2}
                inputProps={{
                  maxLength: 50,
                }}
                onChange={(event) =>
                  this.saveField("TuyenDuong2", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtTenChuTau"
                className={classes.textbox}
                label="Chủ tàu:"
                value={this.state.after.TenChuTau}
                inputProps={{
                  maxLength: 128,
                }}
                onChange={(event) =>
                  this.saveField("TenChutau", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtDiaChi"
                className={classes.textbox}
                label="Địa chi:"
                value={this.state.after.DiaChi}
                inputProps={{
                  maxLength: 200,
                }}
                onChange={(event) =>
                  this.saveField("DiaChi", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtFax"
                className={classes.textbox}
                label="Điện thoại/Fax:"
                value={this.state.after.Fax}
                inputProps={{
                  maxLength: 25,
                }}
                onChange={(event) => this.saveField("Fax", event.target.value)}
              />
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.TrucTiep}
                    onChange={(event) =>
                      this.saveField("TrucTiep", event.target.checked)
                    }
                    name="chkTrucTiep"
                  />
                }
                label="Hỗ trợ trực tiếp"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.GianTiep}
                    onChange={(event) =>
                      this.saveField("GianTiep", event.target.checked)
                    }
                    name="chkGianTiep"
                  />
                }
                label="Hỗ trợ gián tiếp"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.BiDam}
                    onChange={(event) =>
                      this.saveField("BiDam", event.target.checked)
                    }
                    name="chkBiDam"
                  />
                }
                label="Bị đắm"
              />
            </Grid>
            <Grid item xs={4}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={4}>
              <MyButton
                onClick={(event) => {
                  this.setState({ tracuu_menu_anchor: event.currentTarget });
                }}
                color="primary"
                text="Tra cứu thông tin"
              />
            </Grid>
            <Grid item xs={4}>
              {this.state.dataSaved &&
              this.props.stt === 1 &&
              this.props.allowAddMore ? (
                <MyButton
                  onClick={() => {
                    if (this.props.onAddMore) {
                      this.props.onAddMore(this.props.stt);
                    }
                  }}
                  color="primary"
                  text="Thêm phương tiện khác"
                />
              ) : null}
            </Grid>

            <Grid item xs={4}>
              {this.props.stt > 1 ? (
                <MyButton
                  onClick={() => {
                    this.setState({ showConfirmXoa: true });
                  }}
                  color="primary"
                  text="Xóa phương tiện"
                />
              ) : null}
            </Grid>

            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
            {this.state.showConfirmXoa ? (
              <ConfirmDialog
                message="Xóa phương tiện ?"
                callback={(ok) => {
                  if (ok) {
                    this.setState({
                      showConfirmXoa: false,
                      validateStatus: {},
                      saving: true,
                      errorLog: "",
                    });
                    server
                      .post("sukien/removePhuongTien", this.state.after)
                      .then((response) => {
                        var before = {};
                        var after = { ...this.state.after };
                        Object.assign(before, after);
                        this.setState({
                          before: before,
                          after: after,
                          dataChanged: false,
                          canSaved: false,
                          saving: false,
                          errorLog: "",
                          dataSaved: true,
                        });
                        //thong bao cho parent biet co data duoc saved
                        if (this.props.onRemoved) {
                          this.props.onRemoved(this.props.stt);
                        }
                      })
                      .catch((error) =>
                        this.setState({ saving: false, errorLog: error + "" })
                      );
                  } else {
                    this.setState({ showConfirmXoa: false });
                  }
                }}
              />
            ) : null}
          </Grid>
          <Menu
            id="simple-menu"
            anchorEl={this.state.tracuu_menu_anchor}
            keepMounted
            open={Boolean(this.state.tracuu_menu_anchor)}
            onClose={() => this.setState({ tracuu_menu_anchor: null })}
          >
            <MenuItem
              onClick={() =>
                window.open("http://xm.vr.org.vn/TaubienVR/", "_blank")
              }
            >
              Đăng kiểm Việt Nam
            </MenuItem>
            <MenuItem
              onClick={() =>
                window.open(
                  "https://www.marinetraffic.com/en/data/?asset_type=vessels&columns=flag,shipname,photo,recognized_next_port,reported_eta,reported_destination,current_port,imo,ship_type&shipname|begins|shipname=" +
                    encodeURIComponent(this.state.after.TenTau),
                  "_blank"
                )
              }
            >
              MarineTraffic
            </MenuItem>
            <MenuItem
              onClick={() =>
                window.open(
                  "https://www.vesselfinder.com/vessels?name=" +
                    encodeURIComponent(this.state.after.TenTau),
                  "_blank"
                )
              }
            >
              VesselFinder
            </MenuItem>
          </Menu>
          {this.state.open_them_loaitau ? (
            <LoaiTauEditDialog
              visible={this.state.open_them_loaitau}
              fullWidth={true}
              maxWidth={"sm"}
              EditMode="them"
              onClose={(result) => {
                this.setState({ open_them_loaitau: false });
              }}
              onSaved={(record) => {
                var list = [].concat(this.state.source_loaitau);
                var new_item = {
                  value: record.LoaiTau,
                  label: record.TenLoaiTau,
                };
                list.unshift(new_item);
                this.setState({
                  source_loaitau: list,
                  dataChanged: true,
                  canSaved: true,
                  after: { ...this.state.after, LoaiTau: new_item },
                });
              }}
            />
          ) : null}
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
  normalLabel: {
    color: "black",
  },
  redLabel: {
    color: "red",
  },
});
export default withStyles(styles, { withTheme: true })(SuKienPhuongTienControl);
